import { countCountries } from './geo';

export function normalizeBrowser(b) {
  b = b || '';
  if (b.indexOf('Edg') >= 0) {
    // Microsoft Edge, Edg/XX, EdgiOS, EdgA)
    return 'Edge';
  } else if (b.indexOf('IE') >= 0) {
    return 'Internet Explorer';
  } else if (b.indexOf('Chrome Mobile') >= 0) {
    return 'Chrome Mobile';
  } else if (b.indexOf('Chrome') >= 0 && b.indexOf('Mobile Safari') >= 0) {
    return 'Chrome Mobile';
  } else if (b.indexOf('Mobile') >= 0 && b.indexOf('Safari') >= 0) {
    return 'Safari Mobile';
  } else if (b.indexOf('Safari') >= 0) {
    return 'Safari';
  } else if (b.indexOf('Chrome') >= 0) {
    return 'Chrome';
  } else if (b.indexOf('Firefox') >= 0) {
    return 'Firefox';
  } else {
    return 'Other';
  }
}

export function normalizeOS(o) {
  if (!o || !o.trim()) {
    return 'Not reported';
  } else if (o.indexOf('Windows') >= 0) {
    return 'Windows';
  } else if (o.indexOf('Chrome OS') >= 0) {
    return 'Chrome OS';
  } else if (o.indexOf('OS X') >= 0 || o.indexOf('macOS') >= 0) {
    return 'macOS';
  } else if (o.indexOf('iOS') >= 0) {
    return 'iOS';
  } else if (o.indexOf('Android') >= 0) {
    return 'Android';
  } else if (o.indexOf('Linux') >= 0 || o.indexOf('Ubuntu') >= 0) {
    return 'Linux';
  } else {
    return 'Other';
  }
}

export function isTVApp(o) {
  if (!o || !o.trim()) {
    return false;
  } else if (o.indexOf('Roku') >= 0) {
    return true;
  } else if (o.indexOf('AppleTV') >= 0) {
    return true;
  } else if (o.indexOf('Apple TV') >= 0) {
    return true;
  } else if (o.indexOf('Chromecast') >= 0) {
    return true;
  } else if (o.indexOf('ChromeCast') >= 0) {
    return true;
  } else if (o.indexOf('Fire TV') >= 0) {
    return true;
  } else if (o.indexOf('FireTV') >= 0) {
    return true;
  } else {
    return false;
  }
}

export function isMobile(o) {
  if (!o || !o.trim()) {
    return false;
  } else if (o.indexOf('iOS') >= 0) {
    return true;
  } else if (o.indexOf('Android') >= 0) {
    return true;
  } else if (o.indexOf('Mobile') >= 0) {
    return true;
  } else if (o.indexOf('Phone') >= 0) {
    return true;
  } else if (o.indexOf('Tablet') >= 0) {
    return true;
  } else {
    return false;
  }
}

export function normalizeBrowsers(map) {
  var result = {};
  _.each(map, function (count, label) {
    if (!result[normalizeBrowser(label)]) {
      result[normalizeBrowser(label)] = 0;
    }
    result[normalizeBrowser(label)] += count;
  });
  return result;
}

export function normalizeOSs(map) {
  var result = {};
  _.each(map, function (count, label) {
    if (!result[normalizeOS(label)]) {
      result[normalizeOS(label)] = 0;
    }
    result[normalizeOS(label)] += count;
  });
  return result;
}

export function normalizePlatform(osMap, browserMap) {
  var result = { Mobile: 0, Desktop: 0, 'TV App': 0 };
  _.each(osMap, function (count, label) {
    if (isMobile(label)) {
      result.Mobile += count;
    } else {
      result.Desktop += count;
    }
  });

  // XXX: Roku doesn't send the `os` field, so we need to infer it from the browser field
  // and subtract those out of otherwise desktop views.
  _.each(browserMap, function (count, label) {
    if (isTVApp(label)) {
      console.log('detected tv app', label);
      result['TV App'] += count;
      result['Desktop'] -= count;
    }
  });

  return result;
}

export function regionNameFromCode(code, regionDict) {
  var parts = code.split('-');
  if (parts.length != 2 || (parts[0] == '' && parts[1] == '')) return;
  var labelData = regionDict && regionDict[`${parts[1]}-${parts[0]}`];
  var label = (labelData && labelData.join(', ')) || code || 'Unknown Location';

  if (code.startsWith('-')) {
    code = code.replace('-', '');
    _.each(regionDict, function (v, k) {
      if (k.startsWith(code)) {
        label = `${v[0]} (unknown state)`;
      }
    });
  }
  return label;
}

export function normalizeHostData(analytics) {
  var totalViewCountForDestinationPercent = analytics.total_view_count;

  var hostData = [];

  _.keys(analytics.view_counts_by_host).forEach((l) => {
    var viewCount = analytics.view_counts_by_host[l];

    // Clean up some names
    if (!l || l == 'boxcastiframe.com') {
      l = 'Inline Frame (host not reported)';
    }
    if (!l || l == 'BoxCast.tv for AppleTV') {
      l = 'BoxCast.tv for Apple TV';
    }

    // Some special destinations get icons
    var icon = 'icon_website@30px.png';
    if (l == 'twitter.com') {
      icon = 'icon_twitter@30px.png';
    }
    if (l == 'BoxCast.tv for Roku') {
      icon = 'icon_roku@30px.png';
    }
    if (l == 'BoxCast.tv for Apple TV') {
      icon = 'icon_appletv@30px.png';
    }
    if (l == 'BoxCast.tv for Fire TV') {
      icon = 'icon_firetv@30px.png';
    }

    hostData.push({
      label: l,
      value: viewCount,
      percent: (100 * viewCount) / totalViewCountForDestinationPercent,
      icon: icon,
    });
  });

  return _.sortByOrder(hostData, ['value', 'label'], ['desc', 'asc']);
}

export function computeInsights(broadcast, analytics) {
  var insights = {
    watchPercent: 0,
    geo: { countries: 0, states: 0 },
    device: '',
  };

  // Insight: watch percentage
  if (broadcast && broadcast.total_minutes_viewed > 0) {
    var durationSec =
      broadcast.recording_duration_seconds ||
      (moment(broadcast.stops_at) - moment(broadcast.starts_at)) / 1000;
    var durationMin = Math.max(1, durationSec / 60);
    var avgViewDurationMin = broadcast.total_minutes_viewed / analytics.unique_viewer_count;
    insights.watchPercent = 100 * (avgViewDurationMin / durationMin);
  }

  // Insight: geo
  if (analytics.view_counts_by_region_code) {
    insights.geo.countries = countCountries(analytics.view_counts_by_region_code);
    insights.geo.states = _.keys(analytics.view_counts_by_region_code).length;
  }

  // Insight: device
  if (analytics.view_counts_by_os) {
    var os = normalizePlatform(analytics.view_counts_by_os, analytics.view_counts_by_browser);
    var counts = {
      'desktop computers': os.Desktop,
      'mobile devices': os.Mobile,
      'TV apps': os['TV App'],
    };
    insights.device = _.keys(counts).reduce((a, b) => (counts[a] > counts[b] ? a : b));
  }

  return insights;
}



// WEBPACK FOOTER //
// ./app/utils/analytics.js